export default __webpack_public_path__ + "static/media/empathy-map.ef874c6d.png";